import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type {
  articleVocabBoxArticle$data,
  articleVocabBoxArticle$key,
} from "~/queries/__generated__/articleVocabBoxArticle.graphql";

import {
  StyledContentSchemaRender,
  StyledTerm,
  StyledTranslation,
  StyledVocab,
  StyledVocabBox,
} from "./styles";

type Props = {
  content: articleVocabBoxArticle$key;
};

export const ArticleVocabBox: FunctionComponent<Props> = ({ content: content_ }) => {
  const content = useFragment(
    graphql`
      fragment articleVocabBoxArticle on Article {
        glossary {
          term
          translation
          description {
            json
          }
        }
        ...contentSchemaRenderContent
      }
    `,
    content_,
  );

  const renderContent = (glossary: articleVocabBoxArticle$data["glossary"]) => (
    <StyledVocabBox>
      {glossary?.map?.((item, key) => {
        if (!item) return null;
        const { description, term, translation } = item;
        return (
          <StyledVocab key={key}>
            <StyledTerm>{term}</StyledTerm>
            <StyledTranslation>{translation}</StyledTranslation>
            <StyledContentSchemaRender reference={content} schema={description?.json} />
          </StyledVocab>
        );
      })}
    </StyledVocabBox>
  );

  if (!content) return null;
  return renderContent(content.glossary);
};

ArticleVocabBox.displayName = "ArticleVocabBox";
